import useTranslation from "../client/hooks/useTranslation";
import Footer from "../landing-page/components/Footer";

export default function AboutPage() {
  const t = useTranslation();

  return (
    <div className="bg-background text-foreground min-h-screen">
      <main className="isolate">
        <div className="mx-auto max-w-4xl px-6 py-16 lg:px-8 lg:py-24">
          <div className="mx-auto max-w-3xl">
            <h1 className="text-4xl font-bold tracking-tight text-foreground sm:text-5xl">
              {t.landing.footer.about}
            </h1>
            <div className="mt-10 space-y-6 text-base leading-7 text-muted-foreground">
              <p>
                {/* Placeholder content - to be replaced */}
                This is a placeholder for the About page content. The actual content will be provided later.
              </p>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

